import request from './request';

const couponService = {
  /** Paginated list (admin table). */
  getAll: (params) =>
    request.get('dashboard/admin/coupons/paginate', { params }),
  /** Full list alias; supports `?limit`. */
  getAllFlat: (params) =>
    request.get('dashboard/admin/coupons/all', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/coupons/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/coupons', data),
  update: (id, data) => request.put(`dashboard/admin/coupons/${id}`, data),
  toggleStatus: (id) =>
    request.put(`dashboard/admin/coupons/${id}/toggle-status`),
  deleteById: (id) => request.delete(`dashboard/admin/coupons/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/coupons/delete', { data: { ids } }),
  dropAll: () => request.get('dashboard/admin/coupons/drop/all'),
};

export default couponService;
